import { Flex, Text } from "@chakra-ui/react";
import { PropertyFieldViewModel } from "../../types/property-field.view-model";
import { useCustomFormats } from "hooks/useCustomFormat";
import { usePropertyFields } from "../../providers/property-fields-context";

interface PropertyFieldSwitcherProps {
  field: PropertyFieldViewModel;
  isEvenRow: boolean;
}

export function PropertyFieldSwicher({ field, isEvenRow }: PropertyFieldSwitcherProps) {
  const { formatDate, formatCurrency } = useCustomFormats();
  const { getValueOfField } = usePropertyFields();

  const formatValue = () => {
    const value = getValueOfField(field.data_key);

    if (!value) {
      return null;
    }

    switch (field.type) {
      case "date":
      case "datetime":
        return formatDate(value);
      case "boolean":
        return value ? "Yes" : "No";
      case "currency":
        return formatCurrency(value);
      default:
        return value;
    }
  };

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      bg={isEvenRow ? "#F9F8F8" : "transparent"}
      p={4}
      borderRadius="md"
    >
      <Text fontSize="sm" fontWeight="medium">
        {field.label}
      </Text>
      <Text fontSize="sm" fontWeight="medium" color="primary.500">
        {formatValue()}
      </Text>
    </Flex>
  );
}
